var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0237 3.43484L5.4849 5.83496L5.48603 5.836C5.87023 6.09464 6.06233 6.22422 6.27313 6.27418C6.45933 6.31843 6.65473 6.31843 6.84093 6.27418C7.05173 6.22422 7.2444 6.09464 7.62973 5.83496C7.62973 5.83496 9.84936 4.27061 11.0904 3.43484M1.45703 8.53484V4.57973C1.45703 3.99688 1.45703 3.70545 1.58056 3.48271C1.68936 3.28652 1.8622 3.1278 2.07583 3.02788C2.31836 2.91443 2.6357 2.91443 3.27036 2.91443H9.8437C10.4784 2.91443 10.7957 2.91443 11.0377 3.02788C11.2513 3.1278 11.4247 3.28652 11.5335 3.48271C11.657 3.70493 11.657 3.99636 11.657 4.57817V8.53692C11.657 9.11873 11.657 9.40912 11.5335 9.63186C11.4247 9.82777 11.2511 9.987 11.0377 10.0867C10.7957 10.2001 10.4789 10.2001 9.8454 10.2001H3.26866C2.63513 10.2001 2.3178 10.2001 2.07583 10.0867C1.86259 9.98691 1.68922 9.82769 1.58056 9.63186C1.45703 9.40912 1.45703 9.11769 1.45703 8.53484Z",
    stroke: "#242B42",
    strokeWidth: 1.09286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.5df2cf3bd5221822686909249b56a292.svg";
export { ForwardRef as ReactComponent };